import { projectService } from '../../services'
import Vue from 'vue'
import $axios from '@/axios-instance.js'

export class ProjectBase {
  constructor () {
    this.state = {
      all: {
        filterInitialized: false,
        loading: true,
        saving: false,
        items: {},
        currentPage: 1,
        availableTags: {},
        filter: {},
        meta: {},
        cancellationToken: {}
      }
    }
  }

  actions () {
    const that = this
    return {
      initialize ({ commit }) {
        commit('initialize')
      },

      resetFilter ({ commit }) {
        commit('resetFilter')
      },

      getAll ({ commit }) {
        return projectService.getAll().then(data => {
          return data.result
        })
      },

      // Old one
      getProjects ({ commit }) {
        commit('getListDataRequest')

        return projectService.getListData(that.state.all.filter, that.state.all.currentPage)
          .then(data => {
            commit('getListDataSuccess', data.result)
            return data.result
          })
          .catch(error => {
            commit('getListDataFailure', error)
          })
      },

      getListData ({ commit }) {
        commit('getListDataRequest')

        // console.log('GETTING LIST DATA, SHOULD NOT HAPPEN AFTER UPDATE')
        // console.trace()

        return projectService.getListData(that.state.all.filter, that.state.all.currentPage)
          .then(
            data => {
              commit('getListDataSuccess', data.result)
            }
          ).catch(error => {
            if ($axios.isCancel(error)) {
              console.info('Previous request cancelled')
            } else {
              console.error(error)
            }
            return Promise.reject(error)
          })
      },

      getById ({ commit }, id) {
        return projectService.getById(id)
          .then(data => {
            return data.result
          })
      },

      getByProjectCode ({ commit }, id) {
        return projectService.getByProjectCode(id)
          .then(data => {
            return data.result
          })
      },

      getByOwnerId ({ commit }, id) {
        return projectService.getByOwnerId(id)
          .then(data => {
            return data.result
          })
      },

      getByReviewerId ({ commit }, id) {
        return projectService.getByReviewerId(id)
          .then(data => {
            return data.result
          })
      },

      getAllTags ({ commit }) {
        return projectService.getAllTags().then(data => {
          commit('getAllTagsSuccess', data.result)
          return data.result
        })
      },

      create ({ commit, dispatch }, project) {
        commit('startSave')
        return projectService.create(project)
          .then(project => {
            commit('endSave')
            commit('createSuccess', project.result)
            dispatch('getListData')
            return project.result
          }).catch(error => {
            commit('endSave')
            commit('createFailure')
            return Promise.reject(error)
          })
      },

      addTagsToProject ({ commit, dispatch }, { projectId, tags }) {
        commit('startSave')
        return projectService.addTagsToProject(projectId, tags)
          .then(tag => {
            commit('endSave')
            commit('addTagsToProjectSuccess', tag)
            // dispatch('getListData') // No way!
            return tag.result
          }).catch(error => {
            commit('endSave')
            commit('addTagsToProjectFailure')
            return Promise.reject(error)
          })
      },

      update ({ commit, dispatch }, project) {
        commit('startSave')
        return projectService.update(project)
          .then(project => {
            commit('endSave')
            commit('updateSuccess', project.result)
            dispatch('getListData')
            return project.result
          }).catch(error => {
            commit('endSave')
            commit('updateFailure')
            return Promise.reject(error)
          })
      },

      delete ({ commit }, id) {
        commit('startSave')
        commit('deleteRequest', id)
        projectService.delete(id)
          .then(project => {
            commit('endSave')
            commit('deleteSuccess', id)
          })
      }
    }
  }

  getters () {
    return {
      isFilterChanged: state => (route) => {
        // Page should not be considered when comparing
        const currentFilter = Object.assign({}, state.all.filter)
        const defaultFilter = Object.assign({}, state.all.defaultFilter)

        currentFilter.page = null
        defaultFilter.page = null

        return !Vue.lodash.isEqual(currentFilter, defaultFilter)
      }
    }
  }

  mutations () {
    const ret = {
      resetFilter (state) {
        state.all.currentPage = 1
        state.all.filter = Object.assign({}, state.all.defaultFilter)
      },

      initialize (state) {
        if (!state.all.filterInitialized) {
          ret.resetFilter(state)
          state.all.filterInitialized = true
        }
      },

      startSave (state) {
        state.all.saving = true
      },

      endSave (state) {
        setTimeout(() => {
          state.all.saving = false
        }, 200)
      },

      // Get all
      getListDataRequest (state) {
        state.all.loading = true
      },

      getListDataSuccess (state, data) {
        state.all.items = data.items
        state.all.meta = data.meta
        state.all.loading = false
      },

      getListDataFailure (state, error) {
        Vue.prototype.$toast('Kunde inte hämta projekt', 'error')
        console.error(error)
        state.all.error = error
        state.all.loading = false
      },

      getAllTagsSuccess (state, data) {
        state.all.availableTags = data
      },
      // Create
      createSuccess (state, updatedProject) {
        /*
        state.all.items = state.all.items.map(customer =>
          customer.customerId === updatedcustomer.customerId ? updatedcustomer : customer
        )
        */
        Vue.prototype.$toast('Projekt skapat', 'success')
      },

      createFailure (state, error) {
        Vue.prototype.$toast('Kunde inte skapa projekt', 'error')
      },

      addTagsToProjectSuccess (state, tag) {
        // Vue.prototype.$toast('Taggar uppdaterde', 'success')
      },

      addTagsToProjectFailure (state, error) {
        Vue.prototype.$toast('Kunde inte uppdatera taggar', 'error')
      },

      updateSuccess (state, updatedProject) {
        // console.log('IT IS TIME YO UPDATE THE PROJECT LIST')
        // console.log(updatedProject)

        // state.all.items = state.all.items.map(project =>
        //   project.projectId === updatedProject.projectId ? updatedProject : project
        // )

        Vue.prototype.$toast('Projekt uppdaterat', 'success')
      },
      updateFailure (state) {
        Vue.prototype.$toast('Kunde inte uppdatera projektet', 'error')
      },

      deleteRequest (state, id) {
        state.all.items = state.all.items.map(project =>
          project.projectId === id
            ? { ...project, deleting: true }
            : project
        )
      },
      deleteSuccess (state, id) {
        state.all.items = state.all.items.filter(project => project.projectId !== id)
      }
    }

    return ret
  }
}



// WEBPACK FOOTER //
// ./src/store/base-classes/project-base.js